import { createFileRoute } from '@tanstack/react-router'
import AssinarPage from '@/pages/dashboard/assinar-page'

export const Route = createFileRoute('/(dashboard)/dashboard/$dashboardId/assinar')({
  component: function AssinarRoute() {
    return <AssinarPage />
  },
})
